<template>
  <v-img
    :src="src || 'media/icons/logo-gray.svg'"
    :width="logoSize.width"
    :height="logoSize.height"
    :alt="alt"
  />
</template>
<script>
export default {
  name: 'MainLogo',
  props: {
    src: {
      type: String,
      default: 'media/main-logo.svg',
    },
    width: {
      type: [String, Number],
      default: 100,
    },
    height: {
      type: [String, Number],
      default: 50,
    },
    alt: {
      type: String,
      default: 'Logo',
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoSize () {
      if (this.small) {
        return {
          width: 50,
          height: 50,
        }
      }

      return {
        width: this.width,
        height: this.height,
      }
    }
  }
}
</script>
